import * as React from 'react';
import ResizeSensor from 'resize-sensor';
import styles from './scroll-container.scss';

export interface ScrollContainerProps {
  children?: any;
  height?: number;
}

export interface ScrollContainerState {
  left: boolean;
  right: boolean;
  top: boolean;
  bottom: boolean;
}

export class ScrollContainer extends React.PureComponent<ScrollContainerProps, ScrollContainerState> {
  private container: React.RefObject<HTMLDivElement> = React.createRef();
  private sensor:any;

  public state: Readonly<ScrollContainerState> = {left: false, right: false, top: false, bottom: false};

  private addListensers() {
    if(this.container && this.container.current) {
      this.container.current.addEventListener('scroll', this.handleScroll);
      this.sensor = new ResizeSensor(this.container.current, this.handleScroll);
      this.toggleScrollIndicators();
    }
  }
  private removeListeners() {
    if(this.container && this.container.current) {
      this.container.current.removeEventListener('scroll', this.handleScroll);
      this.sensor.detach();
    }
  }

  public componentWillUnmount () {
    this.removeListeners();
  }

  public componentDidMount() {
    this.addListensers();
  }

  private handleScroll = () => {
    this.toggleScrollIndicators();
  };

  private toggleScrollIndicators() {
    if (this.container.current) {

      const el:HTMLDivElement = this.container.current;
      const rtn:ScrollContainerState = {left: false, right: false, top: false, bottom: false};
      if (el.clientWidth !== el.scrollWidth) {
        const scrollPct = el.scrollLeft / (el.scrollWidth - el.clientWidth);
        rtn.left = scrollPct > 0;
        rtn.right = scrollPct < 1;
      }

      if (el.clientHeight !== el.scrollHeight) {
        const scrollPct = el.scrollTop / (el.scrollHeight - el.clientHeight);
        rtn.top = scrollPct > 0;
        rtn.bottom = scrollPct < 1;
      }

      const changed = Object.keys(this.state).reduce((acum, key) => acum || rtn[key] !== this.state[key], false);

      if (changed) {
        this.setState(rtn);
      }
    }
  }

  public render () {
    const {children, height} = this.props;
    const {left, right, top, bottom} = this.state;

    let style:any;
    if (height) {
      style = {height};
    }

    return <div className={styles.indicator}>
      <div className={styles.container} style={style} ref={this.container}>{children}</div>
      {(left || right) && <div className={`${styles.horizontal} ${left ? styles.start : ''} ${right ? styles.end : ''}`}/>}
      {(top || bottom) && <div className={`${styles.vertical} ${top ? styles.start : ''} ${bottom ? styles.end : ''}`}/>}
    </div>;
  }
}
